import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import AdatbekeroPage from "@/pages/AdatbekeroPage";

const rootElement = document.getElementById("root");

const root = createRoot(rootElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/adatbekero" element={<AdatbekeroPage />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
